export default __webpack_public_path__ + "static/cashflow_202_1996_7-8589e27570cb3eff052a480de6dc29d8.jpg";